import axios from 'axios'
import { SALVAR_CIDADES_CONEXAO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function salvarCidadesConexao (conexaoId, cidades) {
  const url = `${URL}/rota/cidades/conexao/${conexaoId}/salvar`;
  return dispatch => axios.post(url, cidades, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: SALVAR_CIDADES_CONEXAO,
        payload: response
      })
  );
}
